import sanitize from 'sanitize-html'

const Sanitized = ({ html, ...rest }) => html
    ? <div dangerouslySetInnerHTML={{ __html: sanitize(html) }} {...rest} />
    : null

export default Sanitized